import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllCentroCustoListaUseCase } from "../../../presentation/useCases/read/get_all_centro_custo_use_case";
import { CentroCustoLista } from "../../models/centro_custo_lista";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * GetAllCentroCustoUseCase
 */

export class GetAllCentroCustoListaUseCase extends BasePaginatedUseCase<CentroCustoLista> implements IGetAllCentroCustoListaUseCase {

  constructor(
    private readonly repository: IComercialRepository) {
    super();

  }

  async getAllCentroCustoLista(
    codigo: string,
    idsCentroCusto: number[],
    status: number,
    page: number,
    rowsPerPage: number

  ): Promise<void> {
    const response = await this.repository.getAllCentroCustoLista(
      codigo,
      idsCentroCusto,
      status,
      page,
      rowsPerPage
    );
    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }

}
